'use strict';

var badge = require('../../../../../../../../../../_virtual/badge.cjs');

var BADGE_SIZES = /*#__PURE__*/ function(BADGE_SIZES) {
    BADGE_SIZES["xsmall"] = "xsmall";
    BADGE_SIZES["small"] = "small";
    BADGE_SIZES["medium"] = "medium";
    return BADGE_SIZES;
}({});

badge.__exports.BADGE_SIZES = BADGE_SIZES;

module.exports = badge.__exports;
//# sourceMappingURL=badge.cjs.map
